<template>
  <div id="app">
    <Menu />
  </div>
</template>

<script>
import Menu from "./components/Menu.vue";

export default {
  name: "App",
  components: {
    Menu
  },
  created() {
    this.$store.dispatch("init");
    if (localStorage.getItem("dungeonWorldCharacterBuilder")) {
      this.$store.commit(
        "loadCharacter",
        localStorage.getItem("dungeonWorldCharacterBuilder")
      );
    }
  }
};
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/*
  Coloring the checkboxes
*/
/* 
.checkbox-wrap > input {
  height: 25px;
  width: 25px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: 1px solid #34495e;
  border-radius: 4px;
  outline: none;
  transition-duration: 0.3s;
  background-color: #41b883;
  cursor: pointer;
}

.checkbox-wrap > input:checked {
  border: 1px solid #41b883;
  background-color: #34495e;
}

.checkbox-wrap > input:checked + .post-checkbox::before {
  content: "\2713";
  display: block;
  text-align: center;
  color: #41b883;
  position: absolute;
  left: 0.7rem;
  top: 0.2rem;
} 

.checkbox-wrap > input:active {
  border: 2px solid #34495e;
} 
/* */

.subnote {
  margin: 0.7em 0;
  font-size: 10px;
}
</style>
